export enum ChartTypeEnum {
    line=<any>'Line',
    spline=<any>'Spline',
    bar=<any>'Bar',
    column=<any>'Column',
    pie=<any>'Pie',
    solidgauge=<any>'Solid Gauge',
    area=<any>'Area',
    scatter=<any>'Scatter',
    treemap=<any>'Treemap',
    wordcloud=<any>'Wordcloud',
    sankey=<any>'Sankey',
    dependencywheel=<any>'Dependency Wheel',
    gauge=<any>'Gauge'
}